import React from 'react';

import {
  Tooltip as MuiTooltip,
  TooltipProps,
  styled,
} from '@mui/material';

import { COLOR_DARK } from '~/components/App/theme';

export const Tooltip = styled(
  (props: TooltipProps & { noSpacing?: boolean }) => {
    const { className, children, noSpacing, sx, ...others } = props;
    return (
      <MuiTooltip
        placement="bottom"
        componentsProps={{
          tooltip: {
            className,
            sx: noSpacing
              ? {
                ...sx,
                bgcolor: 'transparent',
                m: '0 !important',
                p: '0 !important',
              }
              : {
                ...sx,
                mt: '8px !important',
              },
          },
        }}
        {...others}
      >
        {children}
      </MuiTooltip>
    );
  }
)((props) => {
  const { theme: { palette } } = props;
  return ({
    background: palette.primary.contrastText,
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.25)',
    borderRadius: 6,
    padding: '6px 8px',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    color: COLOR_DARK,
    textAlign: 'center',
  })
});
